import {useRouteParams} from '@github-ui/react-core/future/use-route-params'
import {useRouteQuery} from '@github-ui/react-core/future/use-route-query'
import {Outlet} from '@github-ui/react-router'
import {AnalyticsWrapper as BaseAnalyticsWrapper} from '@github-ui/repo-issues-page-layout/AnalyticsWrapper'
import {RepoIssuesPageLayout} from '@github-ui/repo-issues-page-layout/RepoIssuesPageLayout'
import {ReposIssuesSidebar} from '@github-ui/repos-issues-sidebar-ui/ReposIssuesSidebar'
import {useMemo, type ReactNode} from 'react'

import {issuesLayoutRoute} from './issues-layout-route'

type SidebarOptions = {
  owner: string
  repo: string
  hasProjectsEnabled: boolean
}

function renderSidebar(options: SidebarOptions) {
  return function IssuesSidebar(collapsible?: boolean): ReactNode {
    return <ReposIssuesSidebar collapsible={collapsible} {...options} />
  }
}

export function IssuesLayout() {
  const {owner, repo} = useRouteParams(issuesLayoutRoute)
  const {data: layoutPayload} = useRouteQuery(issuesLayoutRoute, 'mainQuery')
  const hasProjectsEnabled = layoutPayload?.has_projects_enabled ?? false

  const renderSidebarFn = useMemo(() => {
    return renderSidebar({
      owner,
      repo,
      hasProjectsEnabled,
    })
  }, [owner, repo, hasProjectsEnabled])

  return (
    <BaseAnalyticsWrapper category={'Repository Label Index'} appName={'issues'}>
      <RepoIssuesPageLayout
        dialogTitle="Labels"
        title="Labels"
        renderSidebar={renderSidebarFn}
        initialExpanded={layoutPayload?.sidebar_expanded ?? undefined}
      >
        <Outlet />
      </RepoIssuesPageLayout>
    </BaseAnalyticsWrapper>
  )
}
